module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Kar98k_C.caac29d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Main/Item_Weapon_Kar98k_C.png
// module id = 224
// module chunks = 0